export default __webpack_public_path__ + "static/media/prev-btn.bd516fac.svg";